import type { MembersAreaPlatformApp } from '../types';
import { editorReady } from './editor-ready';
import { getAppManifest } from './manifest';
import { onEvent } from './on-event';

export { createPrivateAPI } from './private-api';
export { createPublicAPI } from './public-api';

export const currentMembersArea: MembersAreaPlatformApp = {
  editorReady,
  getAppManifest,
  onEvent,
};
